function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import moment from 'moment';
import { chain, trim } from 'lodash';
export var CVResp = /*#__PURE__*/function () {
  function CVResp(q, superq, respmodel, idx) {
    _classCallCheck(this, CVResp);
    _defineProperty(this, "idx", 0);
    _defineProperty(this, "respOriginal", undefined);
    this.q = q;
    this.superq = superq;
    this.respmodel = respmodel;
    this.idx = idx || 0;
  }
  return _createClass(CVResp, [{
    key: "conOriginal",
    value: function conOriginal(listaRespuestas) {
      this.respOriginal = listaRespuestas;
    }
  }, {
    key: "validaPreg",
    value: function validaPreg() {
      return this.respmodel.valid = this._validaPreg();
    }
  }, {
    key: "_validaPreg",
    value: function _validaPreg() {
      if (!this.q.req) return true;
      switch (this.q.tq) {
        case 'FILE':
          try {
            return !!this._nombreFichero();
          } catch (e) {
            return false;
          }
        case 'MULTIPLE':
          return this.__mutipleActivos().length > 0;
        case 'TEXT':
        case 'EMAIL':
        case 'MEMO':
        case 'PARAM':
        case 'PARAM2':
        case 'PARAMOCULTO':
          return !!this._defStr(this.respmodel.t);
        case 'NUMBER':
          return !!this._def(this.respmodel.n);
        case 'DATE':
          return !!this._def(this.respmodel.d);
        case 'YESNO':
          return this.respmodel.yesno.yes || this.respmodel.yesno.no;
        case 'SELECT':
          return !!(this._def(this.respmodel.opt) && this.respmodel.opt);
        default:
          return true;
      }
    }
  }, {
    key: "generaReq",
    value: function generaReq() {
      // sacar valor según el tipo
      var req = {
        idref: this.q.qref,
        idsupref: this.superq && this.superq.qref,
        idx: 0,
        empty: true,
        idopt: null,
        // no se usa
        opt: null,
        // para un multiple
        opts: null,
        // si hay varias opciones marcadas
        text: null,
        num: null,
        f: null,
        val: null,
        sel: null,
        // para un select
        fil: null,
        // para files
        yndet: null // para yesno
      };
      this.__generaModel(req);
      return req;
    }
  }, {
    key: "generaReqEdit",
    value: function generaReqEdit() {
      // los tipo files no se pasan en edición
      if (this.esTipoFile()) {
        return [];
      }

      // sacar valor según el tipo
      var req = {
        idref: this.q.qref,
        idsupref: this.superq && this.superq.qref,
        idx: 0,
        empty: true,
        idopt: null,
        // no se usa
        opt: null,
        // para un multiple
        opts: null,
        // si hay varias opciones marcadas
        text: null,
        num: null,
        f: null,
        val: null,
        sel: null,
        // para un select
        fil: null,
        // para files
        yndet: null,
        // para yesno
        idresporig: this._respOriginal() // la respuesta original
      };
      this.__generaModel(req);
      return [req];
    }
  }, {
    key: "_respOriginal",
    value: function _respOriginal() {
      var _this$respOriginal;
      if ((_this$respOriginal = this.respOriginal) !== null && _this$respOriginal !== void 0 && _this$respOriginal.respuestas.length) {
        return this.respOriginal.respuestas[0].idresp;
      }
      return null;
    }
  }, {
    key: "__generaModel",
    value: function __generaModel(req) {
      req.idx = this.idx;
      switch (this.q.tq) {
        case 'TEXT':
        case 'MEMO':
        case 'EMAIL':
        case 'PARAM':
        case 'PARAM2':
        case 'PARAMOCULTO':
          req.text = this._defStr(this.respmodel.t) || null;
          req.empty = !req.text;
          break;
        case 'DATE':
          req.f = this._def(this.respmodel.d) && new Date(this.respmodel.d) || null;
          req.empty = !req.f;
          break;
        case 'NUMBER':
          req.num = this._def(this.respmodel.n) && this.respmodel.n || null;
          req.empty = !req.num;
          break;
        case 'FILE':
          req.fil = this._fichero();
          req.empty = !req.fil;
          break;
        case 'SELECT':
          req.sel = this._def(this.respmodel.opt) && this.respmodel.opt || null;
          req.empty = !req.sel;
          break;
        case 'MULTIPLE':
          var activos = this.__mutipleActivos();
          var first = activos.length && activos[0] || null;
          req.opts = activos;
          req.empty = !first;
          break;
        case 'ROW':
          req.empty = false;
          break;
        case 'YESNO':
          req.empty = !(this.respmodel.yesno.yes || this.respmodel.yesno.no);
          if (!req.empty) {
            req.val = this.respmodel.yesno.yes || false;

            // incluir los detalles
            if (req.val) {
              req.yndet = this.respmodel.yesno.details;
            }
          }
          break;
        case 'ERROR':
        default:
      }
    }
  }, {
    key: "__mutipleActivos",
    value: function __mutipleActivos() {
      var activos = this.respmodel.opts && chain(this.respmodel.opts).filter(function (o) {
        return o && o.opt != null;
      }).value() || [];
      if (this.q.allowOthers) {
        var others = this.respmodel.others && chain(this.respmodel.others).filter(function (o) {
          return o && !!trim(o.opt);
        }).value() || [];
        return activos.concat(others);
      } else return activos;
    }
  }, {
    key: "_fichero",
    value: function _fichero() {
      try {
        return this._nombreFichero();
      } catch (e) {
        return null;
      }
    }
  }, {
    key: "_nombreFichero",
    value: function _nombreFichero() {
      // debe haber un uploader

      var files = this.uploader.queue;
      if (!files || files.length < this.idx + 1) {
        throw new Error('No hay fichero');
      }

      // debe haber al menos idx files
      var f = files[this.idx];
      return f.file.name;
    }
  }, {
    key: "generaFiles",
    value: function generaFiles() {
      switch (this.q.tq) {
        case 'FILE':
          return [new CVFilePreg(this, this.uploader)];
        default:
          return [];
      }
    }
  }, {
    key: "_def",
    value: function _def(val) {
      return val != undefined && val != null;
    }
  }, {
    key: "_defStr",
    value: function _defStr(val) {
      return this._def(val) && trim(val);
    }

    /**
     * Si es de tipo FILE, el uploader que gestiona los ficheros
     *
     * @param uploader el file uploader
     */
  }, {
    key: "uploaderFiles",
    value: function uploaderFiles(uploader) {
      this.uploader = uploader;
    }
  }, {
    key: "__rellenaTest",
    value: function __rellenaTest() {
      switch (this.q.tq) {
        case 'DATE':
          this.respmodel.d = moment().startOf('week').toDate();
          return;
        case 'TEXT':
        case 'MEMO':
        case 'EMAIL':
          this.respmodel.t = this.respmodel.t || "==".concat(this.q.q, "==").concat(this.idx, "==");
          return;
        case 'NUMBER':
          this.respmodel.n = this.respmodel.n || 1000 + this.idx;
          return;
      }
    }
  }, {
    key: "qref",
    value: function qref() {
      return this.q.qref;
    }
  }, {
    key: "esTipoFile",
    value: function esTipoFile() {
      return this.q.tq === 'FILE';
    }
  }]);
}();
export var CVFilePreg = /*#__PURE__*/function () {
  function CVFilePreg(resp, uploader) {
    _classCallCheck(this, CVFilePreg);
    this.resp = resp;
    this.uploader = uploader;
  }
  return _createClass(CVFilePreg, [{
    key: "filesEnviar",
    value: function filesEnviar() {
      return this.uploader.queue;
    }
  }, {
    key: "idqref",
    get: function get() {
      return this.resp.qref();
    }
  }, {
    key: "idx",
    get: function get() {
      return this.resp.idx != null ? this.resp.idx + '' : null;
    }
  }]);
}();